<template>
  <div>
    <va-icon name="assistant_photo" size="26px" color="blank" style="margin-right: 4px;"/>
    <b style="margin-left:3px;">积分榜</b>
  </div>
  <div class="row grade-list">
    <div class="operation-content invitation" v-for="(item,idx) in tableData" :key="idx">

      <div :class="['user-msg',idx < 5 ? 'ranking'+idx : '']">
        <img :src="item.HeadPic || require('@/static/images/headDefault.jpg')" alt="" class="user-photo">
        <span>{{ item.alias }}</span>
      </div>
      <div class="grade-num">
        <img src="@/static/images/icon-medal.png" alt="" style="    width: 15px;
    height: 15px;margin-right:5px;"/>
        <span>{{ item.Credits }}</span>
      </div>
    </div>
  </div>
  <div>
    <vxe-pager
      background
      v-model:current-page="tablePager.currentPage"
      v-model:page-size="tablePager.pageSize"
      :total="tablePager.totalResult"
      @page-change="handlePageChange"
      :layouts="['PrevJump', 'PrevPage','Jump','PageCount', 'NextPage', 'NextJump','Total']">
    </vxe-pager>
  </div>
</template>
<script>
import {reactive} from 'vue';
import Qs from 'qs'

export default {
  name: "grade",
  components: {},
  data() {
    const tablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const toolbar = reactive({
      loading: false,
      formData: {
        searchKey: ''
      }
    })
    return {
      tableData: null,
      tablePager,
      toolbar,
      dataList: []
    }
  },
  mounted() {
    this.findData()
  },
  methods: {
    findData() {
      const params = {
        'UserId': '',// this.$store.state.userID,
        // 'email': this.$store.state.email,
        'currentPage': this.tablePager.currentPage,
        'pageSize': this.tablePager.pageSize,
        // 'searchKey': [this.toolbar.formData.searchKey]
      };
      this.$api.formsAPI.getUserCredits(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          console.log(res.data.Data);
          this.tableData = res.data.Data.dataTable;

          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.tablePager.totalResult = res.data.Data.totalResult;

        })
        .catch(error => {
          console.log(error);

        })
    },
    handlePageChange() {
      this.findData();
    },
  },
}
</script>

<style scoped lang="scss">
.grade-num {
  text-align: left;
  min-width: 70px;
  line-height: 1;
}

.grade-list {
  position: relative;
  height: 300px;
  align-items: start;
  flex-direction: column;
  overflow-y: scroll;
  flex-wrap: nowrap;
}

.sanjiao {
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 12px;
  color: rgb(51, 51, 51);
  background: rgb(240, 247, 255);
  position: absolute;
}

.sanjiao::before {
  content: "";
  width: 0px;
  height: 0px;
  border-width: 0px 8px 8px;
  border-style: solid;
  border-color: transparent transparent rgb(240, 247, 255);
  display: block;
  transform: rotate(-90deg);
  position: relative;
  position: absolute;
  left: -10px;
  top: 6px;
}

.invitation {
  display: flex;
  padding: .75rem;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  .user-msg {
    position: relative;
    display: flex;
    align-items: center;
  }

  .ranking0::before {
    content: '';
    width: 20px;
    height: 20px;
    background: url('../../../../static/images/ranking1.png');
    background-size: contain;
    position: absolute;
    top: -6px;
    left: -6px;
    z-index: 1;
  }

  .ranking1::before {
    content: '';
    width: 20px;
    height: 20px;
    background: url('../../../../static/images/ranking2.png');
    background-size: contain;
    position: absolute;
    top: -6px;
    left: -6px;
    z-index: 1;
  }

  .ranking2::before {
    content: '';
    width: 20px;
    height: 20px;
    background: url('../../../../static/images/ranking3.png');
    background-size: contain;
    position: absolute;
    top: -6px;
    left: -6px;
    z-index: 1;
  }

  .ranking3::before {
    content: '';
    width: 20px;
    height: 20px;
    background: url('../../../../static/images/ranking4.png');
    background-size: contain;
    position: absolute;
    top: -6px;
    left: -6px;
    z-index: 1;
  }

  .ranking4::before {
    content: '';
    width: 20px;
    height: 20px;
    background: url('../../../../static/images/ranking5.png');
    background-size: contain;
    position: absolute;
    top: -6px;
    left: -6px;
    z-index: 1;
  }

  .boutique::after {
    content: "精";
    display: block;
    position: absolute;
    right: 0px;
    top: 0;

    text-align: center;
    padding: 3px;
    border-radius: 4px;
    font-size: 12px;
    color: #df0e0e;
    background: yellow;
  }

  align-items: center;
  display: flex;

  .link-a {
    position: relative;
    max-width: 220px;
    font-weight: 800;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  .user-name {
    color: #999;
    margin-left: 10px;
    font-size: 12px;
  }

  .user-photo {
    display: inline-block;
    vertical-align: top;
    width: 46px;
    height: 46px;
    margin-right: 10px;
    border-radius: 50%;
  }
}

</style>
